// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2RFAR","location":"Header_location__3rayu"};